import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import purpleTheme from "./purple-passion.json";
// import * as echarts from "echarts/core";
// import { useSelector } from 'react-redux';
import SensorOne from './sensors/SensorOne';
import SensorTwo from './sensors/SensorTwo';
import SensorThree from './sensors/SensorThree';


  
const DashboardPage = () => {
  
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const theme = isdarkMode
  // const {theme } = useSelector(state=>state.theme);  
  // console.log(theme)
  // echarts.registerTheme("purple-passion", purpleTheme);    

  return ( 
    <div className=' flex flex-col gap-5 overflow-hidden overflow-x-auto'>
        <div className="">
          <SensorOne  theme = {theme === false?'light':'dark'}/>
        </div>
        <div className="">  
        <SensorTwo  theme={theme  === false ? 'light':'dark'} />
        </div>
        <div className="">
        <SensorThree theme={theme  === false? 'light':'dark'} />
        </div>
    </div>
  )
}  

export default DashboardPage